import { combineReducers } from 'redux';

// chat
import chat from './chat/reducer';

const rootReducer = combineReducers({
  // public
  chat,
});

export default rootReducer;
